module.exports = __webpack_public_path__ + "static/media/upload_ad.75db4b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upload_ad.png
// module id = 1477
// module chunks = 1